import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import "../../Tabels/Tabels.css";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";

import { Modal, Row, Table } from "react-bootstrap";
import { CancelButton } from "../../common/Button";
import {
  formatDateToIST,
  formatTo12Hour,
  variant_type,
  convertTo12HourFormat,
  formatDate,
} from "../../../utils/common";
import { getData } from "../../../utils/api";
library.add(fas);

const OrderdetailsModal = (props) => {
  const [data, setData] = useState({});
  const GetSingleData = async (id) => {
    const response = await getData(`/admin/orders/order/${id}`);
    if (response?.success) {
      setData(response?.data);
    }
  };

  useEffect(() => {
    if (props.show) {
      GetSingleData(props.show);
    }
  }, [props.show]);

  const { IMG_URL } = useContext(Context);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="section-heading">Order Details</div>
          <div className="order-box">
            {/* <span> <strong> Shipping Address : </strong></span><br></br> */}
            <span>
              <strong> Body Photo : </strong>{" "}
              <img
                src={IMG_URL + data?.body_photo}
                alt="Image"
                className="product-image"
              />{" "}
            </span>
            <br></br>
            <span>
              <strong> Custom note : </strong> {data?.cutom_note} {"No Note"}
            </span>
            <br></br>
            {/* <span><strong>Matrix Status : </strong> {data?.matric_status} {" "}</span><br></br> */}
            <strong>Matrix Status : </strong>{" "}
            {data?.matric_status ? "True" : "False"}
            <br></br>
            <span>
              <strong>Express delivery Status : </strong>{" "}
              {data?.express_delivery_status ? "True" : "False"}{" "}
            </span>
            <br></br>
            <span>
              <strong>Pickup Date : </strong>{" "}
              {formatDateToIST(data?.pickup_date)}{" "}
            </span>
            <br></br>
            <span>
              <strong>Delivery Time : </strong>{" "}
              {formatTo12Hour(data?.delivery_time)}{" "}
            </span>
            <br></br>
            <span>
              <strong>Delivery Date : </strong>{" "}
              {formatDateToIST(data?.delivery_date)}{" "}
            </span>
            <br></br>
            <span>
              <strong>Pickup Time : </strong>{" "}
              {formatTo12Hour(data?.pickup_time)}{" "}
            </span>
            <br></br>
            <strong>Measurement Preference : </strong>{" "}
            {data?.measurement_preference_id && data?.Gender?.name}
            <br></br>
            <br></br>
            <strong>Change Slot Details :</strong>
            <p>
              {data?.Order_Detail_Change_Slots?.length > 0
                ? data.Order_Detail_Change_Slots.map((item) => (
                    <div key={item.id}>
                      <span>
                        <strong>Change Slot message:</strong> {item?.name}
                      </span>
                      <br></br>
                      <span>
                        <strong>Change Slot Reason:</strong>{" "}
                        {item?.Change_Slot?.name}
                      </span>
                      <br></br>
                      <span>
                        <strong>Pickup:</strong> {formatDate(item?.pickup_date)}{" "}-
                        {formatTo12Hour(item?.pickup_time)}
                      </span>
                      <br></br>
                      <span>
                        <strong>Delivery:</strong>{" "}
                        {formatDate(item?.delivery_date)}{" "}-
                        {formatTo12Hour(item?.delivery_time)}
                      </span>
                      <br></br>
                    </div>
                  ))
                : "-"}
            </p>
          </div>

          <div className="section-heading">User Measurement</div>

          <Table bordered responsive>
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Image</th>
                <th>Measurement Field</th>
                <th>Value</th>
                <th>Unit</th>
              </tr>
            </thead>

            <tbody>
              {data?.User_Measurement?.User_Measurement_Details?.length > 0 ? (
                data?.User_Measurement?.User_Measurement_Details.map(
                  (detail, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>

                      <td>
                        {detail?.Measurement_Field?.image ? (
                          <img
                            className="product-image"
                            src={IMG_URL + detail.Measurement_Field.image}
                            alt="Measurement"
                            width="80"
                            height="80"
                          />
                        ) : (
                          "-"
                        )}
                      </td>

                      <td>{detail?.Measurement_Field?.name || "-"}</td>

                      <td>{detail?.name || "-"}</td>

                      <td>{data.User_Measurement?.Unit?.name || "-"}</td>
                    </tr>
                  ),
                )
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    No Measurement Details Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="section-heading">Customer Details</div>
          <div className="order-box">
            {/* <span> <strong> Shipping Address : </strong></span><br></br> */}
            <span>
              <strong> Name : </strong>{" "}
              {data?.Order?.Shipping_Address?.first_name}{" "}
            </span>
            <br></br>
            <span>
              <strong> Email : </strong>{" "}
              {data?.Order?.Shipping_Address?.email}{" "}
            </span>
            <br></br>
            <span>
              <strong> Contact : </strong>
              {data?.Order?.Shipping_Address?.contact_no}{" "}
            </span>
            <br></br>
            <span>
              {" "}
              <strong> Alt Contact : </strong>{" "}
              {data?.Order?.Shipping_Address?.alt_contact_no}
              {"No Alt Contact "}
            </span>
            <br></br>
          </div>

          <div className="section-heading">Delivery Address</div>
          <div className="order-box">
            <span>
              <strong> Street : </strong>{" "}
              {data?.Order?.Delivery_Address?.street} ,
            </span>
            <br></br>
            <span>
              <strong> Address : </strong>{" "}
              {
                data?.Order?.Delivery_Address?.Users_Address_Detail?.Pincode
                  ?.name
              }{" "}
              ,
            </span>
            <span>
              {data?.Order?.Delivery_Address?.Users_Address_Detail?.City?.name}{" "}
              ,
            </span>
            <span>
              {data?.Order?.Delivery_Address?.Users_Address_Detail?.State?.name}{" "}
              ,
            </span>
            <span>
              {
                data?.Order?.Delivery_Address?.Users_Address_Detail?.Country
                  ?.name
              }{" "}
              ,
            </span>
            <br></br>
            {/* <span><strong> Delivery Date : </strong> {data?.Order?.Delivery_Address?.delivery_date}{" "} </span><br></br>
                      <span><strong> Delivery Time : </strong>{data?.Order?.Delivery_Address?.delivery_time}{" "} </span><br></br> */}
          </div>

          <div className="section-heading">Material Address</div>
          <div className="order-box">
            <span>
              <strong> Street : </strong>{" "}
              {data?.Order?.Material_Address?.street}{" "}
            </span>
            <br></br>
            <span>
              <strong> Address : </strong>{" "}
              {
                data?.Order?.Material_Address?.Users_Address_Detail?.Pincode
                  ?.name
              }{" "}
              ,
            </span>
            <span>
              {data?.Order?.Material_Address?.Users_Address_Detail?.City?.name}{" "}
              ,
            </span>
            <span>
              {data?.Order?.Material_Address?.Users_Address_Detail?.State?.name}{" "}
              ,
            </span>
            <span>
              {
                data?.Order?.Material_Address?.Users_Address_Detail?.Country
                  ?.name
              }{" "}
              ,
            </span>
            <br></br>
            {/* <span><strong> Delivery Date : </strong> {data?.Order?.Material_Address?.delivery_date}{" "} </span><br></br>
                      <span><strong> Delivery Time : </strong>{data?.Order?.Material_Address?.delivery_time}{" "} </span><br></br> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default OrderdetailsModal;
